import { IUser } from 'apps/resource-portal/src/app/models/user';
import { AuthService } from 'apps/resource-portal/src/app/services/auth.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { StorageService } from 'libs/core/src/lib/services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
  selector: 'cc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public placeholderImage = "/assets/images/user-icon.png";
  public isLoggedIn = false;
  public onDashboardPage = false;
  public user!: IUser;
  public isScrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 100;
  }

  constructor(private router: Router, private _authService: AuthService, private _storageService: StorageService,
    private _modalService: NgbModal) { }

  ngOnInit(): void {
    this._authService.isLoggedIn.subscribe((value) => {
      if (value) {
        this.isLoggedIn = true;
        this.user = this._authService.$user.value;
      } else {
        this.isLoggedIn = false;
      }
    });
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        if (data.url.includes('dashboard')) {
          this.onDashboardPage = true;
        } else {
          this.onDashboardPage = false;
        }
      }
    });
  }

  gotoDashboard() {
    this.router.navigate(['/dashboard']);
  }

  logout() {
    this._storageService.clearAll();
    this._authService.isLoggedIn.next(false);
    this._authService.$user.next(null);
    this.router.navigate(['/login']);
  }

  userProfile() {
    const modalRef = this._modalService.open(UserProfileComponent, { centered: true, size: 'md', windowClass: 'modal-class', backdrop: 'static' });
    modalRef.componentInstance.data = this.user;
    modalRef.result.then((data) => {
      console.log(data);
    });
  }

}
